<script>
	import LoaderContainer from "../../../../components/Loader/LoaderContainer.svelte";
	import ConfirmModal from "../../../../components/CustomModal/ConfirmModal.svelte";
	import { convert } from "src/services/helpers";
	import { onDestroy } from "svelte";
	import { navigate } from "svelte-routing";
	import { Table } from "@sveltestrap/sveltestrap";
	import { totalRecords } from "src/store/store";
	import Pagination from "../../../../components/CustomPaginate/Pagination.svelte";

	let sortDateReported = 1;
	let sortLastReviewed = 0;

	let numColumn = -1;
	let isOpen = false;
	let id = "";

	let sort = {
		sortCol: "",
		sortDir: "",
	};

	export let data;
	export let handleSort;
	export let filtersAreApplied = false;

	function toggleSort(column) {
		if (numColumn === column) {
			sort.sortDir = sort.sortDir === 0 ? 1 : 0;
		} else {
			sort.sortDir = 0;
		}
		numColumn = column;
		sort.sortCol = column;
		handleSort(sort);
	}

	function toggleModal(num) {
		id = num;
		isOpen = !isOpen;
	}

	function handleSubmit(plateNo) {
		navigate(`/issues/damage-validation/${id}`);
	}

	onDestroy(() => {});
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th
					>Date Reported &nbsp;
					<!-- svelte-ignore a11y-click-events-have-key-events -->
					<!-- svelte-ignore a11y-interactive-supports-focus -->
					<button
						type="button"
						style="background:none;border:none;padding:0;cursor:pointer;color:inherit;vertical-align:middle;"
						on:click={() => toggleSort(sortDateReported)}
						>{#if sort.sortDir === 0 && numColumn === sortDateReported}
							<img
								src="/assets/icon-sort-up-thin.svg"
								alt="icon-sort-up"
							/>
						{:else}
							<img
								src="/assets/icon-sort-down-thin.svg"
								alt="icon-sort-down"
							/>
						{/if}
					</button></th
				>
				<th>Vehicle No.</th>
				<th
					>Last Reviewed &nbsp;
					<!-- svelte-ignore a11y-click-events-have-key-events -->
					<!-- svelte-ignore a11y-interactive-supports-focus -->
					<button
						type="button"
						style="background:none;border:none;padding:0;cursor:pointer;color:inherit;vertical-align:middle;"
						on:click={() => toggleSort(sortLastReviewed)}
						>{#if sort.sortDir === 0 && numColumn === sortLastReviewed}
							<img
								src="/assets/icon-sort-up-thin.svg"
								alt="icon-sort-up"
							/>
						{:else}
							<img
								src="/assets/icon-sort-down-thin.svg"
								alt="icon-sort-down"
							/>
						{/if}
					</button></th
				>
			</tr>
		</thead>
		<tbody>
			{#each data as { plateNo, lastReviewedAt, createdAt, vehicleId, id }}
				<tr on:click={() => toggleModal(id)}>
					<td>{convert(createdAt)}</td>
					<td>
						<span
							class="link link-text"
							on:keydown={() => {}}
							on:click={() =>
								navigate(
									`/car-management/details/${vehicleId}`
								)}
						>
							{plateNo}
						</span>
					</td>
					<td
						>{lastReviewedAt
							? convert(lastReviewedAt)
							: convert(createdAt)}</td
					>
				</tr>
			{/each}
			{#if data.length === 0}
				{#if filtersAreApplied}
					<td colspan="4" class="text-center">
						<div style="font-weight: 700;">
							No results were found.
						</div>
						<div>Try a different set of filters.</div>
					</td>
				{:else}
					<td colspan="4" class="text-center">No data to display</td>
				{/if}
			{/if}
		</tbody>
	</Table>
	<Pagination totalRecord={$totalRecords} />
</LoaderContainer>
<ConfirmModal
	open={isOpen}
	header="Start Validation"
	bodyText="You’re about to start validating this damage. After you start, it will be assigned to you. Do you wish to proceed?"
	buttonText="Confirm"
	buttonColor="primary"
	outline={false}
	handleSubmit={() => handleSubmit(id)}
	toggle={() => (isOpen = false)}
/>
